module.exports = __webpack_public_path__ + "static/14invgde-d2f4117cd862fdcc6c67c93571103c63.gif";